import Vue from "vue";
import VueI18n, { LocaleMessages } from "vue-i18n";
import { ruLocale } from "@/locales/ruRULocale";
import { enLocale } from "@/locales/enENLocale";
import { envVars } from "@/plugins/env-vars";

const createProxy = (originalLocale: any, overRideLocale: any = {}) => {
  return new Proxy(originalLocale, {
    get(target: any, p: PropertyKey, receiver: any): any {
      if (p in overRideLocale) {
        return overRideLocale[p];
      } else {
        return Reflect.get(target, p, receiver);
      }
    }
  });
};

Vue.use(VueI18n);

enum AvailableLocales {
  ru = "ru-RU",
  en = "en-EN"
}

const loadLocaleMessages = (): LocaleMessages => {
  return {
    [AvailableLocales.ru]: {
      ...createProxy(ruLocale, window.OVERRIDE_TRANSLATE.ruLocale)
    },
    [AvailableLocales.en]: {
      ...createProxy(enLocale, window.OVERRIDE_TRANSLATE.enLocale)
    }
  };
};

const lsLocale = localStorage.getItem("localization");
const navigatorLocale = navigator.language;
const envFallbackLocale = envVars.getStr("VUE_APP_LOCALE", AvailableLocales.ru);

const getDefaultLocale = () => {
  const keyLocale: string =
    lsLocale?.substring(0, 2) ??
    navigatorLocale?.substring(0, 2) ??
    envFallbackLocale?.substring(0, 2);

  return AvailableLocales[keyLocale as keyof typeof AvailableLocales];
};

const navigatorLanguage = navigator.language;
const i18n = new VueI18n({
  locale: getDefaultLocale(),
  fallbackLocale: envVars.getStr("VUE_APP_LOCALE", AvailableLocales.ru),
  messages: loadLocaleMessages()
});

// Hot updates
if (module.hot) {
  module.hot.accept(["./ruRULocale", "./enENLocale"], function() {
    i18n.setLocaleMessage("ru-RU", require("./ruRULocale").default);
    i18n.setLocaleMessage("en-EN", require("./enENLocale").default);
  });
}

export { i18n, loadLocaleMessages, AvailableLocales, getDefaultLocale };
